(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Add to cart
  document.querySelectorAll('.product-card__atc').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(btn.getAttribute('data-variant-id'));
      if (!variantId) return;
      btn.disabled = true;
      var originalHTML = btn.innerHTML;
      btn.innerHTML = '<span>Ajout...</span>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: ['cart-icon-bubble', 'cart-drawer'] })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.innerHTML = '<span>Ajouté ✓</span>';
        // Update cart icon bubble
        if (data.sections) {
          var bubbleHTML = data.sections['cart-icon-bubble'];
          if (bubbleHTML) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(bubbleHTML, 'text/html');
            var newBubble = doc.querySelector('.shopify-section');
            var existing = document.getElementById('cart-icon-bubble');
            if (existing && newBubble) existing.innerHTML = newBubble.innerHTML;
          }
          // Open cart drawer if available
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            var drawerHTML = data.sections['cart-drawer'];
            if (drawerHTML) {
              var dDoc = new DOMParser().parseFromString(drawerHTML, 'text/html');
              var dContent = dDoc.querySelector('#CartDrawer');
              var dEl = document.querySelector('#CartDrawer');
              if (dEl && dContent) dEl.innerHTML = dContent.innerHTML;
            }
            drawer.classList.remove('is-empty');
            drawer.open(btn);
          }
        }
        setTimeout(function() {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      });
    });
  });

  const carouselElement = document.querySelector('.product-feature-carousel');
  const isCarouselEnabled = carouselElement.getAttribute('data-carousel-enabled') === 'true';
  
  // Only initialize carousel if enabled
  if (!isCarouselEnabled) return;
  
  const track = document.querySelector('.carousel-track');
  const slides = document.querySelectorAll('.carousel-slide');
  const prevBtn = document.querySelector('.carousel-nav--prev');
  const nextBtn = document.querySelector('.carousel-nav--next');
  const dotsContainer = document.querySelector('.carousel-dots');
  const wrapper = document.querySelector('.carousel-wrapper');
  
  let currentIndex = 0;
  let slidesPerView = parseInt(track.getAttribute('data-products-per-row')) || 3;
  
  // Calculate slides per view based on screen size
  function updateSlidesPerView() {
    const productsPerRow = parseInt(track.getAttribute('data-products-per-row')) || 3;
    
    if (window.innerWidth <= 799) {
      slidesPerView = 1;
    } else if (window.innerWidth <= 1024) {
      slidesPerView = productsPerRow >= 3 ? 2 : productsPerRow;
    } else {
      slidesPerView = productsPerRow;
    }
  }
  
  // Create dots
  function createDots() {
    dotsContainer.innerHTML = '';
    const totalDots = slides.length;
    
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.classList.add('carousel-dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', function() {
        goToSlide(i);
      });
      dotsContainer.appendChild(dot);
    }
  }
  
  // Update dots
  function updateDots() {
    const dots = document.querySelectorAll('.carousel-dot');
    
    dots.forEach(function(dot, index) {
      dot.classList.remove('active');
      if (index === currentIndex) {
        dot.classList.add('active');
      }
    });
  }
  
  // Move carousel (Desktop only)
  function goToSlide(index) {
    if (window.innerWidth <= 799) {
      // Mobile: use native scroll
      const slideWidth = slides[0].offsetWidth;
      const gap = 32;
      wrapper.scrollTo({
        left: index * (slideWidth + gap),
        behavior: 'smooth'
      });
      currentIndex = index;
      updateDots();
      return;
    }
    
    // Desktop: use transform
    const maxIndex = slides.length - slidesPerView;
    currentIndex = Math.max(0, Math.min(index, maxIndex));
    
    const slideWidth = slides[0].offsetWidth;
    const gap = 32;
    const offset = currentIndex * (slideWidth + gap);
    
    track.style.transform = 'translateX(-' + offset + 'px)';
    
    // Update buttons
    if (prevBtn && nextBtn) {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    updateDots();
  }
  
  // Navigation (Desktop only)
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      goToSlide(currentIndex - slidesPerView);
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      goToSlide(currentIndex + slidesPerView);
    });
  }
  
  // Mobile scroll detection
  if (window.innerWidth <= 799 && wrapper) {
    wrapper.addEventListener('scroll', function() {
      const slideWidth = slides[0].offsetWidth + 32; // include gap
      const index = Math.round(wrapper.scrollLeft / slideWidth);
      
      if (index !== currentIndex) {
        currentIndex = index;
        updateDots();
      }
    });
  }
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      goToSlide(currentIndex - slidesPerView);
    } else if (e.key === 'ArrowRight') {
      goToSlide(currentIndex + slidesPerView);
    }
  });
  
  // Resize handler — only reset on width change (height-only = iOS URL bar, ignore)
  let resizeTimer;
  let lastResizeWidth = window.innerWidth;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const newWidth = window.innerWidth;
      if (newWidth === lastResizeWidth) return;
      lastResizeWidth = newWidth;
      updateSlidesPerView();
      createDots();
      goToSlide(0);
    }, 250);
  });
  
  // Initialize
  updateSlidesPerView();
  createDots();
  goToSlide(0);

  // Direction lock: freeze page scroll when swiping horizontally
  if (wrapper) {
    var touchStartX = 0, touchStartY = 0, touchLocked = false;
    wrapper.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchLocked = false;
    }, { passive: true });
    wrapper.addEventListener('touchmove', function(e) {
      if (touchLocked) return;
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 5) {
        touchLocked = true;
        document.documentElement.style.overflowY = 'hidden';
      }
    }, { passive: true });
    wrapper.addEventListener('touchend', function() {
      touchLocked = false;
      document.documentElement.style.overflowY = '';
    }, { passive: true });
  }
});

  } catch(e) { console.error(e); }
})();
})();
